import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";

export const InlineEmailCell = ({ employee, onSave }) => {
  const [value, setValue] = useState(employee.email || "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  useEffect(() => setValue(employee.email || ""), [employee.email]);

  const dirty = value.trim().toLowerCase() !== (employee.email || "");

  const commit = async () => {
    if (!dirty) return;
    setSaving(true);
    const ok = await onSave(employee, value.trim().toLowerCase());
    setSaving(false);
    if (ok) { setSaved(true); setTimeout(() => setSaved(false), 1500); }
    else setValue(employee.email || "");
  };

  return (
    <div className="relative min-w-[220px]">
      <Input
        type="email"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); if (e.key === "Escape") setValue(employee.email || ""); }}
        placeholder="Scrivi l'email e premi Invio"
        className={`h-8 pr-8 text-sm ${!employee.email && !value ? "border-amber-300 bg-amber-50/60 placeholder:text-amber-700/70" : ""}`}
        data-testid={`inline-email-input-${employee.id}`}
      />
      <span className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-slate-400">
        {saving && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
        {!saving && saved && <Check className="h-3.5 w-3.5 text-emerald-600" data-testid={`inline-email-saved-${employee.id}`} />}
      </span>
    </div>
  );
};
